(() => {
  const sections = document.querySelectorAll('.mn-bestsellers-carousel-v1');
  if (!sections.length) return;

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  let lastScrollY = window.scrollY || window.pageYOffset || 0;

  const onPageScroll = () => {
    const currentScrollY = window.scrollY || window.pageYOffset || 0;
    const scrollingDown = currentScrollY >= lastScrollY;
    lastScrollY = currentScrollY;

    sections.forEach((section) => {
      section.classList.add('mn-bestsellers--animate');
      const rect = section.getBoundingClientRect();
      const slides = section.querySelectorAll('.mn-bestsellers-carousel-v1__slide');
      if (!slides.length) return;

      const start = window.innerHeight * 0.96;
      const end = window.innerHeight * 0.14;
      const travel = start - end;
      const progress = clamp((start - rect.top) / travel, 0, 1);

      // Dynamic stagger so the LAST product always reaches full visibility.
      const count = slides.length;
      const stagger = count > 1 ? 0.7 / (count - 1) : 0;
      const windowSize = 0.3;

      slides.forEach((slide, index) => {
        const orderIndex = scrollingDown ? index : count - 1 - index;
        const local = clamp((progress - orderIndex * stagger) / windowSize, 0, 1);

        // Keep cards readable while still cinematic.
        const opacity = 0.22 + local * 0.78;
        const travelX = (1 - local) * 40;
        // Down: appear from left. Up: disappear to right.
        const shiftX = scrollingDown ? -travelX : travelX;

        slide.style.setProperty('--slide-opacity', opacity.toFixed(3));
        slide.style.setProperty('--slide-shift-x', `${shiftX.toFixed(1)}px`);
      });
    });
  };

  onPageScroll();
  window.addEventListener('scroll', onPageScroll, { passive: true });
  window.addEventListener('resize', onPageScroll);
  document.addEventListener('shopify:section:load', onPageScroll);
  document.addEventListener('shopify:section:select', onPageScroll);
})();
